// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-table[data-v-023e8f9b] {\r\n  font-size: 0.75rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
